module.exports = __webpack_public_path__ + "img/pix.2e0fd4a1.png";